var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIngredient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3886 7.5H10.6108C10.183 7.5 9.83301 7.85 9.83301 8.27778C9.83301 8.70556 10.183 9.05556 10.6108 9.05556H18.3886C18.8163 9.05556 19.1663 8.70556 19.1663 8.27778C19.1663 7.85 18.8163 7.5 18.3886 7.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3885 9.83334H10.6107C9.75518 9.83334 9.05518 10.5333 9.05518 11.3889V19.9444C9.05518 20.8 9.75518 21.5 10.6107 21.5H18.3885C19.2441 21.5 19.9441 20.8 19.9441 19.9444V11.3889C19.9441 10.5333 19.2441 9.83334 18.3885 9.83334ZM16.4441 16.8333H15.6663V17.6111C15.6663 18.2567 15.1452 18.7778 14.4996 18.7778C13.8541 18.7778 13.333 18.2567 13.333 17.6111V16.8333H12.5552C11.9096 16.8333 11.3885 16.3122 11.3885 15.6667C11.3885 15.0211 11.9096 14.5 12.5552 14.5H13.333V13.7222C13.333 13.0767 13.8541 12.5556 14.4996 12.5556C15.1452 12.5556 15.6663 13.0767 15.6663 13.7222V14.5H16.4441C17.0896 14.5 17.6107 15.0211 17.6107 15.6667C17.6107 16.3122 17.0896 16.8333 16.4441 16.8333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngredient);
export default __webpack_public_path__ + "static/media/ingredient.78e5cb10.svg";
export { ForwardRef as ReactComponent };